module.exports = __webpack_public_path__ + "img/cross3blue.ac0b4ddb.png";